import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationPipe } from './pipes/duration.pipe'; // Example pipe
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PaginationModule } from './pipes/pagination/pagination.module';

@NgModule({
  declarations: [
    DurationPipe,
  ], // Declare the pipe here
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    DurationPipe,
    TranslatePipe,
    PaginationModule
  ], // Export the pipe so it can be used in other modules
})
export class SharedModule { }
